import React from 'react';
import { injectIntl } from 'react-intl';
import { HeadingCellCommon } from 'Components/widgets/_commonComponents/TableCellComponents';

const ColumnHeaderComponent = injectIntl(({ intl, column }) => {
    return <HeadingCellCommon title={intl.formatMessage({ id:column.displayName })} />;
});

export const ColumnHeader = (props) => <ColumnHeaderComponent {...props} />;
